module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Black.a8f73ca5.eot";